import React from 'react';

const CATEGORY = process.env.REACT_APP_AWARDS_CATEGORY || '';

export default function AwardsCard() {
  return (
    <div className="aw-card reveal in" data-testid="awards-card">
      <div className="medalwrap"><img className="medal" src="/assets/award-finalist-2026-web.jpg" width="130" height="130" alt="Local Business Awards 2026 Finalist — Moreton Bay" /></div>
      <div>
        <span className="eyebrow c">Recognised locally</span>
        <h2>We&rsquo;ve been named a <em>2026 Finalist</em> in The Local Business Awards.</h2>
        <p>Judged by industry peers and voted for by our community, this recognition is about the trust we&rsquo;ve earned across Moreton Bay — one clean, one home, one honest quote at a time. Thank you to every client who nominated us.</p>
        <div className="ann">{CATEGORY ? `Category: ${CATEGORY} · Announced 2026` : 'Announced 2026'}</div>
        <a href="/awards" className="cl-shop" style={{ marginTop: 14, display: 'inline-flex', alignItems: 'center', gap: 7, fontWeight: 800, fontSize: '.9rem', color: 'var(--ink)', borderBottom: '2px solid #bb8a32', paddingBottom: 2 }} data-testid="awards-card-readmore">Read the full story →</a>
      </div>
    </div>
  );
}
